import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModalWithTimer, toggleSpinner } from 'apps/auth/actions/appAction';
import {
    changeFieldProperty,
    changeFormField,
    changeFormFieldValue,
    setFieldError,
    setNewFields,
    updateFields,
    updateFieldValues,
} from 'apps/auth/actions/formAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import { clearLeadingSpace, getSortFields, validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import { FIELDS_SCREEN, PRELOADER, PROMO_SCREEN } from 'apps/auth/components/registration/constants';
import EqualNameAndNameFPopup from 'apps/auth/components/send/popups/errors/EqualNameAndNameFPopup';
import { amplitudeLogout } from 'apps/auth/components/utils/AmplitudeUtils';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import ModalWithTimer from 'apps/auth/components/utils/ModalWithTimer';
import {
    ADRESS_SCREEN_CONTINUE_CLICKED,
    ADRESS_SCREEN_SHOWN,
    LOGOUT_COMPLETED,
    PERSONAL_DETAILS_UPDATED_SHOWN,
    PERSONAL_INFO_SCREEN_CONTINUE_CLICKED,
    PERSONAL_INFO_SCREEN_SHOWN,
    RESIDENTIAL_ADDRESS_UPDATED_SHOWN,
    UNSUPPORTED_CHARACTERS_ACCEPT_CLICKED,
    UNSUPPORTED_CHARACTERS_ERROR_SHOWN,
    UNSUPPORTED_CHARACTERS_GO_BACK_CLICKED,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { COUNTRY_OF_RESIDENCE, FLOW, FROM } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { FRAUD_HARD_BLOCK, SDD } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { ADDRESS, NAME, NAME_F, NATIONALITY, POST_CODE, RESIDENT_COUNTRY, TYPE } from 'apps/auth/constants/fieldsName';
import { TEXT } from 'apps/auth/constants/FieldType';
import { FINISH_REGISTRATION } from 'apps/auth/constants/formName';
import { AUTH_SEND_MAIN_LINK, LOGIN } from 'apps/auth/constants/UrlConstants';
import { logWarn } from 'apps/auth/helpers/clientLogger';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, useFields, usePageMessages } from 'apps/auth/hooks/selectors';
import { fetchCountryRegistrationFields, getFieldsToEdit } from 'apps/auth/services/ProfileService';
import { getRegistrationFields, hasFilledPersonalInfo } from 'apps/auth/services/RegistrationService';

import FailedUnavailableAddressModal from './FailedUnavailableAddressModal';
import LogoutPopup from './LogoutPopup';
import WaitingListModal from './WaitingListModal';
import TellUsAboutYourself from '../promoScreen/TellUsAboutYourself';

const CurrentFieldsScreen = (props) => {
    const submitRef = useRef(null);
    const { formName, phoneCountry, action, location, isSendEvent, extraFields, validationFunc, titleArr = [] } = props;
    const fields = useFields(formName);
    const { continueButton, profileUpdated, personalTitle, personalInfoUpdated, welcomeBackWithName, welcomeToPaysend, welcomeBackToPaysend } =
        usePageMessages();
    const { registrationStep_1_optional, registrationStep_2_optional, phone } = useExtra();
    const [screen, setScreen] = useState(null);
    const [step, setStep] = useState(0);
    const [disabledSubmitButton, setDisabledSubmitButton] = useState(true);
    const [currentFields, setCurrentFields] = useState(getRegistrationFields(extraFields, step));
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    const isNewUser = useRef(props.isNewUser);
    const navigate = useNavigate();

    const title = titleArr.length > 0 ? titleArr[step]?.title : personalTitle;
    const subtitle = titleArr.length > 0 ? titleArr[step]?.subtitle : '';

    const getFiledValue = (fieldName) => `${phone}_${fieldName}`;
    const nameFieldShown = fields?.name?.visible;
    const addressFieldShown = fields?.address?.visible;
    const residentCountry = fields?.resident_country;

    useEffect(() => {
        if (hasFilledPersonalInfo(currentFields, fields)) {
            const nextStep = step + 1;
            const nextFields = getRegistrationFields(extraFields, nextStep);
            if (nextFields.length > 0) {
                setStep(nextStep);
                setCurrentFields(nextFields);
            }
        }
    }, []);

    useEffect(() => {
        setScreen(props.tokenId ? PROMO_SCREEN : PRELOADER);
    }, [props.tokenId]);

    useEffect(() => {
        if (null !== registrationStep_1_optional || typeof registrationStep_1_optional !== 'undefined') {
            let registration_flow = 'all_data_mandatory';
            if (registrationStep_1_optional && registrationStep_2_optional) {
                registration_flow = 'all_data_optional';
            } else if (!registrationStep_1_optional && registrationStep_2_optional) {
                registration_flow = 'personal_data_mandatory';
            }
            amplitude.getInstance().setUserProperties({ registration_flow });
        }
    }, [registrationStep_1_optional, registrationStep_2_optional]);

    useEffect(() => {
        currentFields?.forEach((f) => {
            if (null === f.value || '' === f.value) {
                const newValue = localStorage[getFiledValue(f.name)];
                if (newValue) {
                    props.changeFormFieldValue(formName, newValue, f.name).then(() => {
                        validationAndUpdateValue(formName, newValue, f, props.changeFormField);
                    });
                }
            }
        });
    }, [phone, step]);

    useEffect(() => {
        const updatedFields = [];
        currentFields.forEach((f) => {
            const field = fields[f.name];
            if (field?.value && field?.visible) {
                updatedFields.push(field);
                localStorage.setItem(getFiledValue(f.name), field?.value);
            }
        });
        const errorFields = validationFunc(updatedFields);
        setDisabledSubmitButton(errorFields?.length > 0);
    }, [currentFields, fields]);

    useEffect(() => {
        if (nameFieldShown && !addressFieldShown) {
            amplitude.getInstance().logEvent(PERSONAL_INFO_SCREEN_SHOWN, { [COUNTRY_OF_RESIDENCE]: phoneCountry?.nameEn });
        } else if (addressFieldShown) {
            amplitude.getInstance().logEvent(ADRESS_SCREEN_SHOWN, {
                [COUNTRY_OF_RESIDENCE]: phoneCountry?.nameEn,
                [FLOW]: props.flow || '',
            });
        }
    }, [nameFieldShown, addressFieldShown]);

    useEffect(() => {
        if (formName === FINISH_REGISTRATION && fields?.[POST_CODE]) {
            const type = TEXT;
            props.changeFieldProperty(formName, POST_CODE, TYPE, type);
        }
    }, [residentCountry]);

    const submitHandler = (_responseFields, json) => {
        Object.values(_responseFields)?.forEach((f) => {
            if (f.visible) {
                if (f.name === NAME) {
                    amplitude.getInstance().logEvent(PERSONAL_INFO_SCREEN_CONTINUE_CLICKED);
                } else if (f.name === ADDRESS) {
                    amplitude.getInstance().logEvent(ADRESS_SCREEN_CONTINUE_CLICKED, {
                        [FLOW]: props.flow || '',
                    });
                }
            }
        });
        if (json.messages) {
            props.updatePageMessages(json.messages);
        }
        if (json.extra.sameNameNameFPopup) {
            popupRef?.current?.open(<EqualNameAndNameFPopup popupRef={popupRef} />);
            props.setFieldError(props.formName, NAME_F, json.extra?.errors[NAME_F]);
        } else if (json.extra.suggestionName) {
            amplitude.getInstance().logEvent(UNSUPPORTED_CHARACTERS_ERROR_SHOWN);
            popupRef?.current?.open(
                <SimplePopup popupRef={popupRef} text={<DangerouslyHtml dangerouslyHtml={json.messages?.transliterationTextPopup} />}>
                    <PopupButton
                        iconName="arrow-back-circular"
                        text={json.messages?.goBackAndEditButton}
                        onClick={() => {
                            amplitude.getInstance().logEvent(UNSUPPORTED_CHARACTERS_GO_BACK_CLICKED);
                            popupRef?.current?.close();
                        }}
                    />
                    <PopupButton
                        iconName="arrow-forward"
                        text={json.messages?.acceptAndContinueButton}
                        onClick={() => {
                            amplitude.getInstance().logEvent(UNSUPPORTED_CHARACTERS_ACCEPT_CLICKED);
                            const fields = {
                                name: json.extra.suggestionName,
                                name_f: json.extra.suggestionNameF,
                            };
                            props.updateFieldValues(props.formName, fields).then(() => {
                                submitRef.current?.click();
                                popupRef?.current?.close();
                            });
                        }}
                    />
                </SimplePopup>,
            );
        } else if (json?.extra?.failedUnavailableAddress) {
            modalRef.current?.open(
                <FailedUnavailableAddressModal
                    modalRef={modalRef}
                    json={json}
                    formName={formName}
                    fields={fields}
                    changeFormFieldValue={props.changeFormFieldValue}
                />,
            );
        } else if (json?.extra?.errors && Object.keys(json?.extra.errors).length) {
            setDisabledSubmitButton(true);
            if (json.extra?.backendDidNotResponseForTransliteration) {
                let nameField = fields[NAME];
                nameField.placeholder = json.messages?.placeHolderForName;
                nameField.checkRegexp = json.extra?.latinRegexForName;
                let nameFField = fields[NAME_F];
                nameFField.checkRegexp = json.extra?.latinRegexForName;
                nameFField.placeholder = json.messages?.placeHolderForNameF;
                props
                    .updateFields(props.formName, { nameField, nameFField })
                    .then(Object.keys(json.extra.errors).forEach((name) => props.setFieldError(formName, name, json.extra.errors[name])));
            } else {
                Object.keys(json.extra.errors).forEach((name) => props.setFieldError(formName, name, json.extra.errors[name]));
            }
        } else {
            const nextStep = step + 1;
            currentFields.forEach((f) => {
                localStorage.removeItem(getFiledValue(f.name));
                if (f.name === NAME) {
                    const message = resolveArguments(personalInfoUpdated, fields?.name?.value);
                    props.toggleModalWithTimer(true, message, () => {
                        amplitude.getInstance().logEvent(PERSONAL_DETAILS_UPDATED_SHOWN);
                        props.toggleModalWithTimer(false, '', false);
                    });
                }
            });
            const nextFields = getRegistrationFields(extraFields, nextStep);
            if (Array.isArray(nextFields) && nextFields.length > 0) {
                setStep(nextStep);
                setCurrentFields(nextFields);
            } else {
                if (isSendEvent) {
                    amplitude.getInstance().logEvent('Profile Updated Shown');
                }
                props.toggleModalWithTimer(true, profileUpdated, () => {
                    amplitude.getInstance().logEvent(RESIDENTIAL_ADDRESS_UPDATED_SHOWN);
                    props.toggleSpinner(true);
                    props.toggleModalWithTimer(false, '', false).then(() => {
                        if (props.profileUpdatedFunc) {
                            props.profileUpdatedFunc();
                        } else {
                            navigate(location);
                        }
                    });
                });
            }
        }
    };

    const closeRegistration = (e) => {
        e?.preventDefault();
        if ((step === 0 && !registrationStep_1_optional) || (step === 1 && !registrationStep_2_optional)) {
            popupRef?.current?.open(<LogoutPopup popupRef={popupRef} fromFlow={SDD} />);
        } else {
            window.location.href = AUTH_SEND_MAIN_LINK;
        }
    };

    const getWelcomeMessage = () => {
        let message = welcomeToPaysend;
        if (!isNewUser.current) {
            const addressField = currentFields.find((f) => f?.name === ADDRESS);
            if (addressField && fields?.name?.value) {
                message = resolveArguments(welcomeBackWithName, fields?.name?.value);
            } else {
                message = welcomeBackToPaysend;
            }
        }
        return message;
    };

    const beforeSubmit = () =>
        clearLeadingSpace(
            currentFields.map((f) => fields[f.name]),
            formName,
            props.changeFormFieldValue,
        );

    const clearFieldsOnCountrySelect = () => {
        const fieldsToClear = getFieldsToEdit(extraFields, step);
        fieldsToClear.forEach((f) => {
            if (f.name !== RESIDENT_COUNTRY) {
                props.changeFormFieldValue(formName, null, f.name);
            }
        });
    };

    const logout = () => {
        props.toggleSpinner(true);

        fetch('/logout', { method: 'GET' })
            .then((response) => {
                if (response.ok) {
                    window.location.replace('/login');
                    amplitude.getInstance().logEvent(LOGOUT_COMPLETED, { [FROM]: FRAUD_HARD_BLOCK });
                    amplitudeLogout();
                }
            })
            .catch((error) => {
                logWarn(error);
                props.toggleSpinner(false);
                return null;
            });
    };

    const chooseCountry = (country) => {
        if (residentCountry?.code === country.code) {
            return;
        }
        props.toggleSpinner(true);
        fetchCountryRegistrationFields(country.code)
            .then(({ fields: newFields, messages }) => {
                props.toggleSpinner(false);

                if (!newFields) {
                    modalRef.current?.open(
                        <WaitingListModal
                            modalRef={modalRef}
                            messages={messages}
                            onDismiss={(e) => {
                                e.preventDefault();
                                modalRef.current?.close();
                                props.changeFormFieldValue(formName, `${phoneCountry?.id}`, residentCountry.name);
                            }}
                            primaryButtonOnClick={logout}
                            backUrl={LOGIN}
                        />,
                    );
                    return;
                }
                props.setNewFields(formName, newFields);
                setCurrentFields(getSortFields(newFields));
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    if (screen === PRELOADER) {
        return <ModalWithTimer text={getWelcomeMessage()} onClick={() => setScreen(PROMO_SCREEN)} />;
    } else if (screen === PROMO_SCREEN) {
        return (
            <TellUsAboutYourself
                onContinueClick={() => {
                    setScreen(FIELDS_SCREEN);
                }}
                topButtonOnClick={closeRegistration}
            />
        );
    } else if (screen === FIELDS_SCREEN) {
        return (
            <>
                <CommonPage showChat={false} isBackButton leftCloseIcon={true} onClickIcon={() => setScreen(PROMO_SCREEN)} hasBottomPanel>
                    <HeaderPanel title={title} subtitle={subtitle} />
                    <Form
                        id="updateProfile"
                        formName={formName}
                        action={action}
                        getCanonicalPath={true}
                        checkNotVisibleField={false}
                        onSubmitHandler={submitHandler}
                        fieldsForSubmit={currentFields}
                        beforeSubmit={beforeSubmit}
                    >
                        <fieldset>
                            {currentFields.map((f) => {
                                const field = fields[f.name];
                                if (field) {
                                    return (
                                        <fieldset key={`${formName}-fields-${field.name}`}>
                                            <InputAutoDetect
                                                formName={formName}
                                                field={field}
                                                country={phoneCountry}
                                                clearFieldsOnCountrySelect={clearFieldsOnCountrySelect}
                                                hasCountryItemPanel={field.name === RESIDENT_COUNTRY || field.name === NATIONALITY}
                                                selectHandler={chooseCountry}
                                            />
                                        </fieldset>
                                    );
                                }
                            })}
                        </fieldset>
                        <FixedBottomPanel isRightAligned>
                            <Button type="submit" form="updateProfile" raised={true} caption={continueButton} disabled={disabledSubmitButton} ref={submitRef} />
                        </FixedBottomPanel>
                    </Form>
                </CommonPage>
                <PopupNew ref={popupRef} />
                <ModalNew ref={modalRef} />
            </>
        );
    }
};
CurrentFieldsScreen.propTypes = {
    formName: PropTypes.string,
    phoneCountry: PropTypes.object,
    location: PropTypes.string,
    action: PropTypes.string,
    isSendEvent: PropTypes.bool,
    extraFields: PropTypes.array,
    validationFunc: PropTypes.func,
    titleArr: PropTypes.array,
    profileUpdatedFunc: PropTypes.func,
    flow: PropTypes.string,
};
export default connect(null, {
    toggleSpinner,
    setFieldError,
    changeFieldProperty,
    changeFormField,
    changeFormFieldValue,
    toggleModalWithTimer,
    updateFieldValues,
    updatePageMessages,
    updateFields,
    setNewFields,
})(CurrentFieldsScreen);
